export const API = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export const fetchAuth = (url, token) => {
  return fetch(API + url, {
    headers: { Authorization: token }
  }).then(r => r.json());
};
